import { render, staticRenderFns } from "./Val.vue?vue&type=template&id=47495bc1&scoped=true&"
import script from "./Val.vue?vue&type=script&lang=js&"
export * from "./Val.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47495bc1",
  null
  
)

export default component.exports